import React from "react";
import { SelectInput } from "react-admin";
import { NationalityType } from "utils/choices";
import StudentsByCourseAndGroup from "./StudentsByCourseAndGroup";

// Same filters as the plain report plus an optional nationality - left empty, all students are included.
const ExtendedStudentsByCourseAndGroup = ({ handleParamChange }) => {
  return (
    <>
      <StudentsByCourseAndGroup handleParamChange={handleParamChange} />
      <SelectInput
        choices={NationalityType}
        source="nationalityType"
        label="Националност"
        onChange={e => handleParamChange("nationalityType", e.target.value)}
      />
    </>
  );
};

export default ExtendedStudentsByCourseAndGroup;
